import React, { useEffect, useCallback } from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import {
  Modal,
  ModalVariant,
  Button,
  TextContent,
  Text,
  TextVariants,
} from "@patternfly/react-core";

import {
  REQUESTED_PRODUCTS,
  REQUESTED_UPDATE_PRODUCT,
} from "../../redux/actions/productAction";
import {
  REQUESTED_PRODUCT_SUITES,
  REQUESTED_UPDATE_PRODUCT_SUITE,
} from "../../redux/actions/productSuiteAction";
import {
  REQUESTED_PRODUCT_GROUPS,
  REQUESTED_UPDATE_PRODUCT_GROUP,
} from "../../redux/actions/productGroupAction";
// import { REQUESTED_ACTIVITIES } from "../../redux/actions/activityAction";

export default (props) => {
  const { isModalOpen, handleModalToggle, type } = props;

  const mapState = useCallback(
    (state) => ({
      isUpdatingProductSuite: state.productSuiteState.isUpdatingProductSuite,
      isUpdatedProductSuite: state.productSuiteState.isUpdatedProductSuite,
      isUpdatingProduct: state.productState.isUpdatingProduct,
      isUpdatedProduct: state.productState.isUpdatedProduct,
      isUpdatingProductGroup: state.productSuiteState.isUpdatingProductGroup,
      isUpdatedProductGroup: state.productSuiteState.isUpdatedProductGroup,
    }),
    []
  );

  const {
    isUpdatingProductSuite,
    isUpdatedProductSuite,
    isUpdatingProduct,
    isUpdatedProduct,
    isUpdatingProductGroup,
    isUpdatedProductGroup,
  } = useMappedState(mapState);

  const dispatch = useDispatch();

  function handleConfirm() {
    switch (type) {
      case "product":
        dispatch({
          type: REQUESTED_UPDATE_PRODUCT,
          payload: {
            product: {
              id: props.product.id,
              is_draft: !props.product.is_draft,
            },
          },
        });
        break;
      case "product suite":
        dispatch({
          type: REQUESTED_UPDATE_PRODUCT_SUITE,
          payload: {
            productSuite: {
              id: props.productSuite.id,
              productSuite: { is_draft: !props.productSuite.is_draft },
            },
          },
        });
        break;
      case "product group":
        dispatch({
          type: REQUESTED_UPDATE_PRODUCT_GROUP,
          payload: {
            productGroup: {
              id: props.productGroup.id,
              productGroup: { is_draft: !props.productGroup.is_draft },
            },
          },
        });
        break;
      default:
        console.log(`the prop type is ${props.type}`);
    }
    handleModalToggle();
  }

  useEffect(() => {
    if (isUpdatedProduct) {
      dispatch({
        type: REQUESTED_PRODUCTS,
        payload: {},
      });
    }
    if (isUpdatedProductSuite) {
      dispatch({
        type: REQUESTED_PRODUCT_SUITES,
        payload: {},
      });
    }
    // if (isUpdatedProductSuite || isUpdatedProduct) {
      // dispatch({
      //   type: REQUESTED_ACTIVITIES,
      //   payload: {},
      // });
    // }
  }, [dispatch, isUpdatedProductSuite]);

  function renderText() {
    if (props.type === "product suite") {
      return (
        <TextContent>
          <Text component={TextVariants.p}>
            You are going to{" "}
            {props.productSuite && props.productSuite.is_draft
              ? "publish"
              : "unpublish"}{" "}
            product suite{" "}
            <strong>{props.productSuite && props.productSuite.name}</strong>.
            Please confirm this action.
          </Text>
        </TextContent>
      );
    } else if (props.type === "product") {
      return (
        <TextContent>
          <Text component={TextVariants.p}>
            You are going to{" "}
            {props.product && props.product.is_draft ? "publish" : "unpublish"}{" "}
            product <strong>{props.product && props.product.name}</strong>.
            Please confirm this action.
          </Text>
        </TextContent>
      );
    } else if (props.type === "product group") {
      return (
        <TextContent>
          <Text component={TextVariants.p}>
            You are going to{" "}
            {props.productGroup && props.productGroup.is_draft
              ? "publish"
              : "unpublish"}{" "}
            product group{" "}
            <strong>{props.productGroup && props.productGroup.name}</strong>.
            Please confirm this action.
          </Text>
        </TextContent>
      );
    }
  }

  return (
    <Modal
      variant={ModalVariant.small}
      title="Confirmation Required"
      isOpen={isModalOpen}
      onClose={handleModalToggle}
      actions={[
        <Button
          isDisabled={
            isUpdatingProductSuite ||
            isUpdatingProduct ||
            isUpdatingProductGroup
          }
          key="Confirm"
          variant="primary"
          onClick={handleConfirm}
        >
          Confirm
        </Button>,
        <Button key="Cancel" variant="secondary" onClick={handleModalToggle}>
          Cancel
        </Button>,
      ]}
    >
      {renderText()}
    </Modal>
  );
};
